import { useEffect, useRef, useState } from 'react';
import { Caption, Coin, GuideContainer, GuideBlock, GuideInnerBlock, GuideTitle, GuideTitleBlock } from './styles.css';
import textData from '../../../../data/data.json';
import { selectedLanguageAtom } from '../../../../recoil/atoms/languageAtom';
import { useRecoilValue } from 'recoil';

export const SessionGuide = ({ isOpen }) => {
    const selectedLanguage = useRecoilValue(selectedLanguageAtom);
    const { sessionGuide } = textData[selectedLanguage];
    const ref = useRef();
    const [guideStyles, setGuideStyles] = useState(null);

    useEffect(() => {
        const computedStyle = getComputedStyle(ref.current);
        setGuideStyles({
            minHeight: ref.current.scrollHeight + 'px',
            padding: computedStyle.padding,
        });
    }, []);

    useEffect(() => {
        if (isOpen && guideStyles) {
            ref.current.style.minHeight = guideStyles.minHeight;
            ref.current.style.maxHeight = guideStyles.minHeight;
            ref.current.style.padding = guideStyles.padding;
        } else {
            ref.current.style.minHeight = 0;
            ref.current.style.maxHeight = 0;
            ref.current.style['padding-top'] = 0;
            ref.current.style['padding-bottom'] = 0;
        }
    }, [isOpen, guideStyles]);

    return (
        <GuideContainer ref={ref}>
            <GuideBlock>
                <GuideTitleBlock>
                    <Coin>1</Coin>
                    <GuideTitle dangerouslySetInnerHTML={{ __html: sessionGuide.sections[0].title }} />
                </GuideTitleBlock>

                <GuideInnerBlock>
                    {sessionGuide.sections[0].captions.map((caption, index) => (
                        <Caption key={index} sx={{ textAlign: 'left' }}>
                            {caption}
                        </Caption>
                    ))}
                </GuideInnerBlock>
            </GuideBlock>

            <GuideBlock>
                <GuideTitleBlock>
                    <Coin>2</Coin>
                    <GuideTitle dangerouslySetInnerHTML={{ __html: sessionGuide.sections[1].title }} />
                </GuideTitleBlock>

                <GuideInnerBlock>
                    {sessionGuide.sections[1].captions.map((caption, index) => (
                        <Caption key={index} sx={{ textAlign: 'left' }}>
                            {caption}
                        </Caption>
                    ))}
                </GuideInnerBlock>
            </GuideBlock>

            <GuideBlock>
                <GuideTitleBlock>
                    <Coin>3</Coin>
                    <GuideTitle>{sessionGuide.sections[2].title}</GuideTitle>
                </GuideTitleBlock>

                <GuideInnerBlock>
                    {sessionGuide.sections[2].captions.map((caption, index) => (
                        <Caption key={index} sx={{ textAlign: 'left' }}>
                            {caption}
                        </Caption>
                    ))}
                </GuideInnerBlock>
            </GuideBlock>

            <GuideBlock>
                <GuideTitleBlock>
                    <Coin>4</Coin>
                    <GuideTitle>{sessionGuide.sections[3].title}</GuideTitle>
                </GuideTitleBlock>

                <GuideInnerBlock>
                    {sessionGuide.sections[3].captions.map((caption, index) => (
                        <Caption key={index} sx={{ textAlign: 'left' }}>
                            {caption}
                        </Caption>
                    ))}
                </GuideInnerBlock>
            </GuideBlock>

            <GuideBlock>
                <GuideTitleBlock>
                    <Coin>5</Coin>
                    <GuideTitle>{sessionGuide.sections[4].title}</GuideTitle>
                </GuideTitleBlock>

                <GuideInnerBlock>
                    {sessionGuide.sections[4].captions.map((caption, index) => (
                        <Caption key={index} sx={{ textAlign: 'left' }}>
                            {caption}
                        </Caption>
                    ))}
                </GuideInnerBlock>
            </GuideBlock>
        </GuideContainer>
    );
};
